import { Button } from '@mui/material';
import React from 'react'
import Modal from '../../components/Modal'
import TextInput from '../../components/TextField'
import SelectInput from '../../components/SelectInput'
import DateInput from '../../components/DateInput'
import { CKEditorCustomToolbar, EmployeeType, EmployStatus } from '../../constants'
import { Switch } from '@mui/material'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react';


const EditJobDetailsModal = ({ data, methods, id }) => {
  const {
    jobDetailsModal,
    jobDetailsInputs,
    error,
    allShiftList,
    allRolesList,
    reportManagerData,
  } = data
  const {
    handleDateChange,
    handleJobDetailupdate,
    handleBlur,
    setError,
    handleInputChange,
    setJobDetailsInputs,
    handleJobDetailAdd,
    clear,
    clearOnStatus
  } = methods

  const empStatus=(type)=>{
    setJobDetailsInputs((pre)=>({...pre,empStatus:type}))
    clearOnStatus()
  }
  return (
    <div>
      <Modal
        size="xl"
        show={jobDetailsModal.open}
        onHide={() => { clear(); }}
        headerContent={< h5 className="py-2" >{jobDetailsModal.type === 'NEW' ? 'Add' : 'Edit'} Job Details</h5 >}
        bodyContent={
          <div>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked={jobDetailsInputs?.empStatus === 'ACTIVE'}  onClick={()=>empStatus('ACTIVE')} />
              <label className="btn btn-outline-primary" for="btnradio1">Active</label>

              <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autocomplete="off" checked={jobDetailsInputs?.empStatus === 'ONHOLD'} onClick={()=>empStatus('ONHOLD')}/>
              <label className="btn btn-outline-primary" for="btnradio2">On Hold</label>

              <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autocomplete="off" checked={jobDetailsInputs?.empStatus === 'RELIEVED'} onClick={()=>empStatus('RELIEVED')}/>
              <label className="btn btn-outline-primary" for="btnradio3">Relieved</label>
            </div>
            <div className="row">
              {/* <div className="col-lg-4 mt-4">
                <SelectInput
                  Lable={'Employment Status'}
                  width={'310px'}
                  Options={EmployStatus}
                  keyName={'title'}
                  className="form-field-design"
                  Name="empStatus"
                  SelectValue={jobDetailsInputs?.empStatus}
                  // HandleChange={handleInputChange}
                  HandleChange={(e) => { handleInputChange(e); clearOnStatus() }}
                  // HandleChange={(e)=>{console.log(e,'eeeeeeeeeeeeee')}}
                  onBlur={handleBlur}
                  Error={error?.empStatus}
                  variant={'outlined'}
                  isRequired={true}
                />
              </div> */}
              {
                jobDetailsInputs?.empStatus === 'ACTIVE' ?
                  <>
                    <div className="col-lg-4 mt-4">
                      <TextInput
                        Lable="Designation"
                        Name="designation"
                        variant="outlined"
                        ClassName="form-field-design"
                        HandleInputChange={handleInputChange}
                        // onBlur={handleBlur}
                        Value={jobDetailsInputs?.designation}
                        width={100}
                        // Require={true}
                        Error={error?.designation}
                      />
                    </div>
                    <div className="col-lg-4 mt-4">
                      <DateInput
                        className="w-100 form-field-design"
                        isRequired={true}
                        Label={'Date of Joining'}
                        handleDateChange={(date) => { handleDateChange(date, 'dateOfJoining'); setError((pre) => ({ ...pre, dateOfJoining: '' })) }}
                        SelectedDate={jobDetailsInputs?.dateOfJoining}
                      />
                      {error?.dateOfJoining && <span className='text-danger' style={{ fontSize: "11px" }}>{error?.dateOfJoining}</span>}
                    </div>
                    <div className="col-lg-4 mt-4">
                      <SelectInput
                        Lable={'Employee Type'}
                        width={'310px'}
                        Options={EmployeeType}
                        keyName={'title'}
                        className="form-field-design"
                        Name="empType"
                        SelectValue={jobDetailsInputs?.empType}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.empType}
                        variant={'outlined'}
                        isRequired={true}
                      />
                    </div>
                    <div className="col-lg-4 mt-4">
                      <SelectInput
                        Lable={'Shift'}
                        width={'310px'}
                        Options={allShiftList}
                        keyName={'name'}
                        className="form-field-design"
                        Name="shift"
                        SelectValue={jobDetailsInputs?.shift}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.shift}
                        variant={'outlined'}
                        isRequired={true}
                      />
                    </div>
                    <div className="col-lg-4 mt-4">
                      <SelectInput
                        Lable={'Roles'}
                        Options={allRolesList}
                        keyName={'roleTitle'}
                        className="form-field-design"
                        Name="role_id"
                        SelectValue={jobDetailsInputs?.role_id}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.role_id}
                        variant={'outlined'}
                        isRequired={true}
                      />
                    </div>
                    <div className="col-lg-4 mt-4">
                      <SelectInput
                        Lable={'Reporting Manager'}
                        width={'310px'}
                        Options={reportManagerData}
                        keyName={'fullNameAndEmail'}
                        className="form-field-design"
                        Name="reportingManager"
                        SelectValue={jobDetailsInputs?.reportingManager}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.reportingManager}
                        variant={'outlined'}
                      />
                      {jobDetailsInputs?.reportingManager?.length ? <p className='float-end text-danger pointer mt-1' onClick={() => setJobDetailsInputs((pre) => ({ ...pre, reportingManager: null }))}>Remove Reporting Manager</p> : null}
                    </div>
                    <div className="col-lg-4 mt-4">
                      <TextInput
                        Lable="Probation Days"
                        Name="probationDays"
                        variant="outlined"
                        ClassName="form-field-design"
                        HandleInputChange={handleInputChange}
                        onBlur={handleBlur}
                        Value={jobDetailsInputs?.probationDays}
                        width={100}
                        Require={true}
                        type={'number'}
                        Error={error?.probationDays}
                      />
                    </div>
                    <div className="col-lg-4 mt-5">
                      <label htmlFor="" style={{ fontSize: '13px', color: 'rgba(0, 0, 0, 0.6)' }}>Earn leave caluculate</label>
                      <Switch checked={jobDetailsInputs?.elCalculate} onChange={(e) => setJobDetailsInputs((pre) => ({ ...pre, elCalculate: e.target.checked }))} />
                    </div>
                  </>
                  :
                  <div className="col-lg-12 mt-4">
                    <DateInput
                      className="w-100 form-field-design"
                      isRequired={true}
                      Label={'Action Date'}
                      handleDateChange={(date) => { handleDateChange(date, 'actionDate'); setError((pre) => ({ ...pre, actionDate: '' })) }}
                      SelectedDate={jobDetailsInputs?.actionDate}
                    />
                    {error?.actionDate && <span className='text-danger' style={{ fontSize: "11px" }}>{error?.actionDate}</span>}
                  </div>
              }



              <div className="col-lg-12 mt-4">
                <label>Remarks
                  {jobDetailsInputs?.empStatus !== 'ACTIVE' && <span className='text-danger'> *</span>}
                </label>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    toolbar: CKEditorCustomToolbar,
                  }}
                  data={jobDetailsInputs.remark}
                  onChange={(event, editor) => {
                    const data = editor.getData()
                    setJobDetailsInputs((pre) => ({ ...pre, remark: data }))
                    setError((pre) => ({ ...pre, remark: '' }))
                  }}
                />
                {error?.remark && <span className='text-danger' style={{ fontSize: "11px" }}>{error?.remark}</span>}
              </div>
            </div>
            <div className="d-flex justify-content-end mt-4">
              <Button variant="outlined" onClick={() => clear()} data-bs-dismiss="modal">
                Cancel
              </Button>
              {
                jobDetailsModal.type === 'NEW' ?
                  <Button variant="contained" className="ms-2" onClick={() => handleJobDetailAdd(id)}>
                    Submit
                  </Button>
                  :
                  <Button variant="contained" className="ms-2" onClick={() => handleJobDetailupdate(id)}>
                    Update
                  </Button>
              }
            </div>
          </div >
        }
      />
    </div>
  )
}

export default EditJobDetailsModal